import { AxiosRequestConfig } from "axios";
import { Api as ApiV1 } from "generated/CoreApi_v1";
import { AxiosInterceptorsHandler } from "providers/AxiosInterceptorsHandler";
import React, { PropsWithChildren } from "react";
import { SessionService } from "services/sessionService";
import { SessionStore } from "../services/SessionStore";

////////////////////////////////////////////////////////////////////////////////

type SecurityData = {
    authenticationHeader: string;
};

export const coreApiV1 = new ApiV1<SecurityData>(
    {
        baseURL: SessionService.current.apiPaths.coreApi,
        format: "json",
        secure: true,
        securityWorker: (securityData: SecurityData | null) => {
            var config: AxiosRequestConfig = {
                headers: {
                    "x-performa-origin": window.location.hostname,
                    "authorization": SessionStore.bearerString()
                    //"authorization": securityData?.authenticationHeader ?? ""
                }
            };
            return config;
        }
    });

////////////////////////////////////////////////////////////////////////////////

export type CoreApiContextType = {
    v1: ApiV1<SecurityData>;
};

const contextValue: CoreApiContextType = { v1: coreApiV1 };

const CoreApiContext = React.createContext<CoreApiContextType>(contextValue);

////////////////////////////////////////////////////////////////////////////////

export const useCoreApi = () => React.useContext(CoreApiContext);

////////////////////////////////////////////////////////////////////////////////

export const CoreApiProvider: React.FC<PropsWithChildren> = ({ children }) => {
    return (
        <CoreApiContext.Provider value={contextValue}>
            <AxiosInterceptorsHandler instances={[contextValue.v1.instance]}>
                {children}
            </AxiosInterceptorsHandler >
        </CoreApiContext.Provider>
    );
};

export const isCanceledError = (error: any): boolean => (error && error.name && error.name == 'CanceledError');
